"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styles = require("../Table/styles.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var styles = function styles(theme) {
  var _responsiveStacked;

  if (!("scrollbars" in theme)) {
    theme.scrollbars = {
      main: {}
    };
  }

  return _objectSpread(_objectSpread({}, (0, _styles.styles)(theme)), {}, {
    paper: {
      boxShadow: "none"
    },
    clickable: {
      cursor: "pointer"
    },
    sortAction: {
      cursor: "default"
    },
    responsiveScrollFullHeight: _objectSpread({}, theme.scrollbars.main),
    responsiveScrollMaxHeight: _objectSpread({}, theme.scrollbars.main),
    largeSelectCell: {
      border: "none"
    },
    largeSelectCellTransparent: {
      border: "none",
      backgroundColor: "transparent !important"
    },
    largePaper: {
      backgroundColor: "transparent"
    },
    largeHeaderCellFixed: {
      backgroundColor: "".concat(theme.palette.background.paper, " !important")
    },
    largeHeaderSelectFixed: {
      backgroundColor: theme.palette.background.paper
    },
    cellStacked: (0, _defineProperty2.default)({}, theme.breakpoints.down("sm"), {
      // Table Headers
      minHeight: "24px",
      height: "auto",
      width: "100%",
      padding: "".concat(theme.spacing(1.5), "px 0 0 ").concat(theme.spacing(1.5), "px !important"),
      border: "none",
      fontWeight: "bold",
      background: "#fff",
      fontSize: ".8em !important",
      "&:nth-last-of-type(2)": {
        borderBottom: "none"
      },
      overflowX: "auto" // Since the rows won't line up if we wrap the overflow

    }),
    responsiveStacked: (_responsiveStacked = {}, (0, _defineProperty2.default)(_responsiveStacked, theme.breakpoints.down("sm"), {
      "& tr": {
        minHeight: "24px",
        height: "auto",
        marginBottom: "1em !important",
        "& td": {
          width: "100%",
          height: "auto",
          background: "#fff",
          padding: "0 0 ".concat(theme.spacing(1.5), "px ").concat(theme.spacing(1.5), "px"),
          whiteSpace: "initial",
          border: "none"
        }
      }
    }), (0, _defineProperty2.default)(_responsiveStacked, "td", {
      "&:last-of-type": {
        borderBottom: "none"
      },
      overflowX: "auto" // Since the rows won't line up if we wrap the overflow

    }), _responsiveStacked),
    paddingCheckbox: (0, _defineProperty2.default)({}, theme.breakpoints.down("sm"), {
      padding: 0
    }),
    tableCellRoot: {
      padding: theme.spacing(0.5, 1.5)
    },
    button: {
      "&:hover": {
        color: theme.palette.primary.main
      }
    },
    toolbar: {
      paddingLeft: 0,
      paddingRight: 0
    },
    toolbarSelectRoot: {
      padding: "0 26px",
      zIndex: 1,
      backgroundColor: theme.palette.background.paper
    },
    toolbarSelectTitle: {
      paddingLeft: 0,
      paddingRight: "26px"
    },
    toolbarSelectIconButton: {
      marginRight: 0
    },
    assetThumbnail: {
      display: "block",
      marginRight: "-54px",
      maxHeight: "50px",
      maxWidth: "50px"
    },
    filterPaper: (0, _defineProperty2.default)({
      // media query for Internet Explorer 11 blur when rendering 3d transform
      "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)": {
        transform: "scale(1) !important"
      },
      // mui-datatables uses some negative margins, this accounts for those
      maxWidth: "calc(100% - 32px)",
      minWidth: "900px"
    }, theme.breakpoints.down("md"), {
      minWidth: 0,
      width: "100%"
    }),
    gridListTile: {
      marginTop: 0
    },
    gridListRoot: {
      // Prevent wobble when selecting options in autocomplete
      maxWidth: "866px",
      // Override grid list inline styles
      margin: "".concat(theme.spacing(-1), "px !important")
    },
    gridListTileRoot: (0, _defineProperty2.default)({
      // Override grid list inline styles
      padding: "".concat(theme.spacing(1), "px !important")
    }, theme.breakpoints.down("sm"), {
      width: "100% !important"
    }),
    filterRoot: (0, _defineProperty2.default)({}, "@media screen and (min-width: ".concat(theme.breakpoints.values.md, "px) and (-ms-high-contrast: active), screen and (min-width: ").concat(theme.breakpoints.values.md, "px) and (-ms-high-contrast: none)"), {
      minWidth: "900px"
    })
  });
};

exports.styles = styles;